import { combineLatest, map, take, tap } from 'rxjs';
import {
  selectCoreAvailableModules,
  selectUserAccessLevel,
} from '../../reducers';

import { AppState } from 'src/app/reducers';
import { Component, DestroyRef, inject, Input } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { UserAccessLevel } from '../../services/user.service';
import { switchActiveModule } from '../../actions/core.actions';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export interface ModuleOption {
  id: number;
  name: string;
  url: string;
  icon: IconProp;
  active: boolean;
  accessLevel: UserAccessLevel;
}

@Component({
    selector: 'app-module-switch',
    templateUrl: './module-switch.component.html',
    styleUrl: './module-switch.component.scss',
    standalone: false
})
export class ModuleSwitchComponent {
  @Input() showActiveInfo: boolean = false;

  availableModules: ModuleOption[];
  activeModule: ModuleOption;

  protected destroyRef = inject(DestroyRef);
  constructor(
    private store: Store<AppState>,
    private router: Router,
  ) {
    combineLatest([
      this.store.select(selectCoreAvailableModules),
      this.store.select(selectUserAccessLevel),
    ])
      .pipe(
        // first, compute the filtered list based on access level
        map(([modules, level]) =>
          modules.filter((module) => level >= module.accessLevel),
        ),
        // then perform side-effects: assign the filtered list and pick the active module
        tap((filteredModules) => {
          this.availableModules = filteredModules;
          // pick the first one marked active (or null if none)
          this.activeModule = filteredModules.find((m) => m.active) ?? null;
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  ngOnInit(): void {}

  switchModule(module: ModuleOption): void {
    this.store.dispatch(switchActiveModule({ moduleId: module.id }));
    this.router.navigate([module.url]);
  }
}
